import { CSSProperties } from 'react';

export const showIf = (condition: boolean): CSSProperties =>
  condition ? {} : { display: 'none' };

export const hideIf = (condition: boolean): CSSProperties => showIf(!condition);
